import styled, { css } from 'styled-components';

import { Z_INDEX } from '~/common/constants/z-index';

export const AboveContainer = styled.div<{
  popover: boolean;
}>`
  position: relative;
  z-index: ${Z_INDEX.TOOLTIP};

  ${({ popover }) =>
    !popover &&
    css`
      @media (max-width: 750px) {
        display: none;
        opacity: 0;
      }
    `}
`;
